import { apiRequestEnvelope } from '@scc/lib'
import type {
  LaunchRepository,
  LaunchProgressMonth,
} from '@/data/repositories/types'

interface ProgressMeta {
  dataThrough: string | null
}

export function createApiLaunchRepository(): LaunchRepository {
  async function fetchProgress(
    clientId: string,
    start: string,
    months: number,
  ): Promise<{ months: LaunchProgressMonth[]; dataThrough: string | null }> {
    const { data, meta } = await apiRequestEnvelope<LaunchProgressMonth[], ProgressMeta>(
      `/analytics/launch/progress?start=${encodeURIComponent(start)}&months=${months}`,
      { headers: { 'X-Store-Id': clientId } },
    )
    return { months: data, dataThrough: meta?.dataThrough ?? null }
  }

  return {
    async getProgressActuals(
      clientId: string,
      start: string,
      months: number,
    ): Promise<LaunchProgressMonth[]> {
      const result = await fetchProgress(clientId, start, months)
      return result.months
    },
    getProgressActualsWithMeta: fetchProgress,
  }
}
